import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-date-operator',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.css']
})
export class DateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
